import { useTranslation } from 'react-i18next';
import type { Report } from '../../types';
import ReportStudio from './ReportStudio';
import { useAuth } from '../../shared/hooks/useAuth';
import ReportSample from './ReportSample';
import GenerateOrDownload from './GenerateOrDownload';
import ReportSummary from './ReportSummary.tsx';

type ReportProps = {
  report: Report;
  patientId: string;
};

const ReportActions = ({ report, patientId }: ReportProps) => {
  const { t } = useTranslation();
  const auth = useAuth();

  const emailContact = t('email privacy');
  const cleanedMsg = (msg: string) => msg.replace(/Buongiorno sig. (.*?)\. /i, '');

  return (
    <>
      <div>
        <span className="font-bold">{t('code')}:</span> {report?.codice}
      </div>
      <div>
        <div>
          <div className="my-4" dangerouslySetInnerHTML={{ __html: cleanedMsg(report?.messaggio) }}></div>
          {auth && auth.abtest === 'sauton' ? (
            <>
              <div className="mt-8 mb-4">
                <ReportSummary patientId={auth?.user?.username || ''} />
              </div>
              <div className="mt-8 mb-4">
                <ReportSample patientId={auth?.user?.username || ''} />
              </div>
              <div className="max-w-xl my-4">
                <GenerateOrDownload
                  link="sauton/docs/prodotti_test_genetico.pdf"
                  linkLabel={t('products brochure cta')}
                  handler={() => {}}
                />
              </div>
              <div className="mt-4 mb-8">
                <ReportStudio report={report} patientId={patientId} />
              </div>
            </>
          ) : (
            <>
              <div className="mt-4 mb-8">
                {report.referto_studio == 1 ? <ReportSample patientId={auth?.user?.username || ''} /> : null}
              </div>
              <div className="mt-4 mb-8">
                <ReportStudio report={report} patientId={patientId} />
              </div>
            </>
          )}
        </div>
      </div>
      <div>
        <div
          className="mt-8 text-sm"
          dangerouslySetInnerHTML={{
            __html: t('gdpr delete', {
              linkMailPrivacyStart: `<a href="mailto:${emailContact}">`,
              linkMailPrivacyEnd: '</a>',
            }),
          }}
        ></div>
      </div>
    </>
  );
};

export default ReportActions;
